module.exports = __webpack_public_path__ + "f7f64135311ecd551b46aa26c2181361.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/fonts/bulorounded-light.woff
 ** module id = 4
 ** module chunks = 0
 **/